__webpack_require__.p = "/std-manage-frontend/";